// 'use strict';
// import 'slick-carousel';
// import $ from "jquery";
import calculator from './modules/calculator';
import openMenu from './modules/openMenu';
import slider from './modules/slider';
import openItems from './modules/openitems';
import tabs from './modules/tabs';
import modal from './modules/modal';
import smallCalc from './modules/smallCalc';
import portfolioSlider from './modules/portfolioSlider';
import {showOne} from "./modules/calculator";
import jquery from "jquery";
import $ from "jquery";

window.addEventListener('DOMContentLoaded', () => {

  try {
    openMenu('.header', '.button_burger', '.button_header_menu_close', '.header_nav');
  } catch(e) {
    // console.log(e)
  } 

  try {
    slider();
  } catch(e) {
    // console.log(e)
  } 

  try {
    openItems();
  } catch(e) {
    // console.log(e)
  } 

//  '.free_price_about_design'

  try {
    const simpleModal = document.querySelector('.order_repair');
    const simpleForm = document.querySelector('.simple_form');

    let messError = simpleModal.querySelector('.mess_err');
    let messSuccess = simpleModal.querySelector('.mess_success');
    $(".simple_form").on("submit", function (t) {
      t.preventDefault()
      // alert('work')
      var phone, name, source, term, formname, medium, campaign, content
      name = $(this).find('.name').val()
      phone = $(this).find('.tel').val() 
      source = $(this).find('.source').val() 
      term = $(this).find('.term').val() 
      formname = $(this).find('.formname').val() 
      medium = $(this).find('.medium').val() 
      campaign = $(this).find('.campaign').val() 
      content = $(this).find('.content').val()  
      $.ajax({
          url: "mail.php",
          method: "POST",
          data: {
              name: name,
              phone: phone,
              source: source,
              term: term,
              formname: formname,
              medium: medium,
              campaign: campaign,
              content : content 

          },
          success: function (t) {
              // window.dataLayer = window.dataLayer || [];
              // dataLayer.push ({
              // 'event': 'formSuccess',
              // 'formName': formname,
              // });
              messSuccess.textContent = 'Спасибо, мы получили вашу заявку. Свяжемся с вами в рабочее время';
              messError.textContent = '';
      
              simpleForm.reset();
          },
          error: function (t) {
              messSuccess.textContent = ' ';
              messError.textContent = 'Извините, что-то пошло не так. Попробуйте снова.';
          }
      })
    })
  } catch(e) {
    // console.log(e);

    // console.log('Ошибка');
  } 

  try {
    const orderModal = document.querySelector('.order_call');
    const orderCallForm = document.querySelector('.order_call_form');

    let messError = orderModal.querySelector('.mess_err');
    let messSuccess = orderModal.querySelector('.mess_success');

    $(".order_call_form").on("submit", function (t) {
      t.preventDefault()
      // alert('work')
      var phone, name, source, term, formname, medium, campaign, content
      name = $(this).find('.name').val()
      phone = $(this).find('.tel').val() 
      source = $(this).find('.source').val() 
      term = $(this).find('.term').val() 
      formname = $(this).find('.formname').val() 
      medium = $(this).find('.medium').val() 
      campaign = $(this).find('.campaign').val() 
      content = $(this).find('.content').val() 
      $.ajax({
          url: "mail.php",
          method: "POST",
          data: {
              name: name,
              phone: phone,
              source: source,
              term: term,
              formname: formname,
              medium: medium,
              campaign: campaign,
              content : content 

          },
          success: function (t) {
              // window.dataLayer = window.dataLayer || [];
              // dataLayer.push ({
              // 'event': 'formSuccess',
              // 'formName': formname,
              // });
              messSuccess.textContent = 'Спасибо, мы получили вашу заявку. Свяжемся с вами в рабочее время';
              messError.textContent = '';
      
              orderCallForm.reset();
          },
          error: function (t) {
              messSuccess.textContent = ' ';
              messError.textContent = 'Извините, что-то пошло не так. Попробуйте снова.';
          }
      })
    })
  } catch(e) {
    // console.log(e);

    // console.log('Ошибка');
  } 

  try {

    const withDesignModal = document.querySelector('.get_free_price');
    const whithDesignForm = document.querySelector('.free_price_about_design');

    let messError = withDesignModal.querySelector('.mess_err');
    let messSuccess = withDesignModal.querySelector('.mess_success');

 

    $(function() {
      document.querySelector('.free_price_about_design').addEventListener('submit', function(evt){
        var http = new XMLHttpRequest(), f = this;
        var th = $(this);
        evt.preventDefault();
        http.open("POST", "contact.php", true);
        http.onreadystatechange = function() {
          if (http.readyState == 4 && http.status == 200) {
            // alert(http.responseText);
            // if (http.responseText.indexOf(f.nameFF.value) == 0) { // очистить поля формы, если в ответе первым словом будет имя отправителя (nameFF)

            //   th.trigger("reset");
            messSuccess.textContent = 'Спасибо, мы получили вашу заявку. Свяжемся с вами в рабочее время';
            messError.textContent = '';
    
            whithDesignForm.reset();
          }
        }
        http.onerror = function() {
          messSuccess.textContent = ' ';
          messError.textContent = 'Извините, что-то пошло не так. Попробуйте снова.';
        }
        http.send(new FormData(f));
      }, false);
     
    });
  } catch(e) {
    // console.log(e);

    // console.log('Ошибка');
  } 

  try {
    portfolioSlider();
  } catch(e) {
    // console.log(e)
  } 

  function addShow(arr, item, elemClass) {
      arr.forEach(item => item.classList.remove(elemClass));
      item.classList.add(elemClass);
    }

  try {
    
    function togglePortfolio() {
      const typeBtns = document.querySelectorAll('.menu__type__item ');
      const typeRooms = document.querySelectorAll('.portfolio_type');
      // const roomsBtn = document.querySelectorAll('.menu__rooms__item ');
      try {
        typeRooms.forEach((item) => {
          const rooms = item.querySelectorAll('.rooms');
          const roomsBtn = item.querySelectorAll('.menu__rooms__item ');
          addShow(rooms, rooms[0], 'show');

          roomsBtn.forEach((btn, i) => {
            btn.addEventListener('click', () => {
              addShow(rooms, rooms[i], 'show');
              addClassForOneElement(roomsBtn, btn, 'menu__rooms__item--active');
            })
          })
        })
      } catch(e) {

      }

      addShow(typeRooms, typeRooms[0], 'show');
      

      function addClassForOneElement(arr, elem, elemClass) {
        arr.forEach(item => item.classList.remove(elemClass));
        elem.classList.add(elemClass);
      }

      addClassForOneElement(typeBtns, typeBtns[0], 'type__item__text--active');

      typeBtns.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          addShow(typeRooms, typeRooms[i], 'show');
          addClassForOneElement(typeBtns, typeBtns[i], 'type__item__text--active');
        })
      })

     
    }

    togglePortfolio();
  } catch(e) {
    // console.log(e)
  } 

  function openPrice(container, opened, triggerBtn, openClass) {
    const items = document.querySelectorAll(container);

   items.forEach((item) => {
      const openedText = item.querySelector(opened);
      const btn = item.querySelector(triggerBtn);

      btn.addEventListener('click', () => {
        openedText.classList.toggle('show');
        btn.classList.toggle(openClass);
        
      })
    })
  }

  try {
    if(window.innerWidth < 1200) {
      
      openPrice('.tab_list__item', '.tab_text', '.tab_title', 'tab_title--opened');
    } else {
      tabs();
    }
   
    } catch(e) {
      // console.log(e)
    } 

  try {
    smallCalc();
  } catch(e) {
    console.log(e)
  }

  try {
    calculator();
  } catch(e) {
    // console.log(e)
  } 

  // Modals
  try {
    modal('.adv_btn', '.get_free_price', '.get_free_price__close');
  } catch(e) {
    // console.log(e)
  } 

  
  try {
    modal('.order_call_btn', '.order_call', '.order_call__close');
  } catch(e) {
    // console.log(e)
  } 

  try {
    modal('.order_repair_btn', '.order_repair', '.order_repair__close');
  } catch(e) {
    // console.log(e)
  } 

  try {
    openPrice('.full_price_list__works', '.full_price_list__wrapper', '.works_name', 'works_name--opened');
  } catch(e) {
    // console.log(e)
  } 

  try {
    function openFullPrice() {
      const btns = document.querySelectorAll(".price__nav_link");
      const items = document.querySelectorAll(".full_price_list__works");
      let btnAtr, itemAtr;
        
      addShow(btns, btns[0], 'price__nav_link--active');

        btns.forEach((btn) => {
          btn.addEventListener('click', () => {
            btnAtr = btn.getAttribute('data-name');
            addShow(btns, btn, 'price__nav_link--active');
            
            items.forEach((item) => {
              itemAtr = item.getAttribute('id');
              const itemBtn = item.querySelector('.works_name');
              const itemOpened = item.querySelector('.full_price_list__wrapper');
    
              if( itemAtr === btnAtr) {
                itemBtn.classList.add('works_name--opened');
                itemOpened.classList.add('show');
              }
            })
          })
          
        })
    }

    openFullPrice();
  } catch(e) {
    // console.log(e)
  } 
       
});



